<template>
	<el-card class="box-card" shadow="hover" style="min-width:1200px;">
		<el-row :gutter="10">
			<el-col :span="20">
				<el-input :placeholder="'请输入'+s_name+'名称关键字(模糊检索)'" v-model="searchName" class="input-with-select">
					<el-select v-model="school_search" slot="prepend" placeholder="请选择学校" :disabled="school_hidden">
						<!-- <el-option label="全部学校" value=""> </el-option> -->
						<el-option v-for="item in getSchoolArray" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-input>
			</el-col>
			<el-col :span="4">
				<slot></slot>
			</el-col>
		</el-row>
	</el-card>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	export default {
		data() {
			return {
				//筛选条件
				searchName: '',
				school_search: '',
				school_hidden: false
			}
		},
		props: {
			s_name: {
				type: String
			},
			getSchoolArray: {
				type: Array
			}
		},
		watch: {
			searchName(val) {
				this.$emit('searchName', this.searchName)
			},
			school_search(val) {
				this.$emit('school_search', this.school_search)
			},
			getSchoolArray(val) {
				if (val && this.getUserInfo.schoolID) {
					this.school_search = this.getUserInfo.schoolID
					if (this.school_search) this.school_hidden = true
				}
			}
		},
		computed: {
			...mapGetters(['getUserInfo'])
		}
	}
</script>

<style lang="scss">
	.el-select .el-input {
		width: 150px;
	}

	.input-with-select .el-input-group__prepend {
		background-color: #fff;
	}
</style>
